// Copyright 2021-2022 zcloak authors & contributors
// SPDX-License-Identifier: Apache-2.0

import Event from 'eventemitter3';

export const event = new Event();
